// @flow
import type { BasketItem, TestSchedule, ShoppingList, ShoppingListItem } from "../lib/Types";

// Stores the items in the users basket
// (consider replacing with mobx if there are performance issues)
export default class BasketData {
  items: Map<string, BasketItem>;
  subscribers: Array<() => void>;

  constructor(companyId) {
    this.companyId = companyId;
    this.subscribers = [];
    this.load();
  }

  subscribe = (callback: Function): void => {
    this.subscribers.push(callback);
  };

  unSubscribeAll = () => (this.subscribers = []);

  unsubscribe = func => (this.subscribers = this.subscribers.filter(i => i !== func));

  notifySubscribers = (): void => this.subscribers.forEach(f => f());

  basketItems = (): Array<BasketItem> => Array.from(this.items.values());

  getCount = (product_id: number, test_schedule: TestSchedule) => {
    const object = this.items.get(this._key(product_id, test_schedule));
    return object ? object.count : 0;
  };

  convertShoppingListtoBasketItems = (shoppingList: ShoppingList): Array<BasketItem> => {
    const basketItems = [];

    shoppingList.items.map(shoppingListItem => {
      const product = {
        id: shoppingListItem.product_id,
        name: shoppingListItem.product_name,
        schedules: []
      };
      const test_schedule = {
        client_suite_id: shoppingListItem.client_suite_id,
        client_suite_name: shoppingListItem.client_suite_name,
        client_specification_id: shoppingListItem.client_specification_id,
        client_specification_name: shoppingListItem.client_specification_name,
        sample_information_id: shoppingListItem.sample_information_id,
        sample_information_name: shoppingListItem.sample_information_name
      };
      basketItems.push({
        count: 1,
        product,
        test_schedule
      });
    });
    return basketItems;
  };

  addShoppingListToBasket = (shoppingList: ShoppingList) => {
    shoppingList.items.map(shoppingListItem => {
      const product = {
        id: shoppingListItem.product_id,
        name: shoppingListItem.product_name,
        schedules: []
      };
      const test_schedule = {
        client_suite_id: shoppingListItem.client_suite_id,
        client_suite_name: shoppingListItem.client_suite_name,
        client_specification_id: shoppingListItem.client_specification_id,
        client_specification_name: shoppingListItem.client_specification_name,
        sample_information_id: shoppingListItem.sample_information_id,
        sample_information_name: shoppingListItem.sample_information_name
      };

      const key = this._key(product.id, test_schedule);
      const item = this.items.get(key);

      this.addSchedule({
        count: item ? item.count + 1 : 1,
        product,
        test_schedule
      });
    });
  };

  // Updates the schedule count in the basket.
  // Removes the schedule if the count is 0.
  addSchedule = ({ product, test_schedule, count }: BasketItem) => {
    const key = this._key(product.id, test_schedule);
    if (count === 0) {
      this.items.delete(key);
    } else {
      this.items.set(key, {
        product,
        test_schedule,
        count
      });
    }
    this.save();
    this.notifySubscribers();
  };

  clearBasket = () => {
    this.items = new Map();
    this.save();
    this.notifySubscribers();
  };

  save = () => {
    localStorage.companyId = this.companyId;
    localStorage.itemsMap = JSON.stringify(Array.from(this.items.entries()));
  };

  load = () => {
    if (JSON.parse(localStorage.companyId || 0) === this.companyId) {
      this.items = new Map(JSON.parse(localStorage.itemsMap || "[]"));
    } else {
      this.items = new Map([]);
    }
  };

  sampleCount = (): number => {
    var sum = 0;
    this.basketItems().map(i => (sum += i.count));
    return sum;
  };

  uniqueScheduleCount = (): number => this.basketItems().length;

  _key = (product_id: number, test_schedule: TestSchedule): string => {
    return JSON.stringify([
      product_id,
      test_schedule.client_suite_id,
      test_schedule.client_specification_id,
      test_schedule.sample_information_id
    ]);
  };
}
